
export const getLabels = ({ labelsReducer: { labels = [] } = {} }) => labels;
export const getLabelFilter = ({ labelsReducer: { filter = {} } = {} }) => filter;
export const getLabelsCount = ({ labelsReducer: { count = 0 } = {} }) => count;
